import { useCallback, useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { getData } from "../../services/base.service";
import CustomDrawer from "../Shared/CustomDrawer";
import { ProjectDetail, ProjectOptions } from "../../types/projectTypes";
import ProjectForm from "./ProjectForm";

type ProjectDetailsProps = {
    projectId: number;
    onClose: () => void;
    setLoading: Function;
    // Called after any save so the list/cards pick up the new figures.
    onSaved: () => void;
};

function ProjectDetails({ projectId, onClose, setLoading, onSaved }: ProjectDetailsProps) {
    const [detail, setDetail] = useState<ProjectDetail | null>(null);
    const [options, setOptions] = useState<ProjectOptions | null>(null);
    const [error, setError] = useState<string | null>(null);

    const loadDetail = useCallback(async () => {
        try {
            setError(null);
            const result = await getData(`projects/detail/${projectId}`);
            setDetail(result as ProjectDetail);
        } catch (err) {
            setError((err as Error).message);
        }
    }, [projectId]);

    useEffect(() => {
        setDetail(null);
        loadDetail();
    }, [loadDetail]);

    useEffect(() => {
        getData('projects/options').then((res) => setOptions(res as ProjectOptions)).catch((err) => console.error(err));
    }, []);

    const refresh = async () => {
        await loadDetail();
        onSaved();
    };

    return (
        <CustomDrawer open toggleDrawer={onClose} vw={45} minPx={420} maxPx={1100} title="Project Details" orientation="right">
            {error ? (
                <Typography color="error">Could not load the project: {error}</Typography>
            ) : !detail || !options ? (
                <Box display="flex" justifyContent="center" paddingY={8}><CircularProgress /></Box>
            ) : (
                <ProjectForm detail={detail} options={options} setLoading={setLoading} refresh={refresh} />
            )}
        </CustomDrawer>
    );
}

export default ProjectDetails;
